import { actions, mutations } from "@/constants/state";
import { checkDomain } from "@/services/domain-service";

export default {
  [actions.DOMAIN_FETCH_ACTION]: async ({ commit }) => {
    const { data } = await checkDomain(window.location.hostname);
    commit(mutations.DOMAIN_FETCH_MUTATION, data);
  },
};
